module.exports = "\r\n\r\n<div class=\"main-container {{hiddenClass}}\">\r\n    <ng-container *ngTemplateOutlet=\"addBarTemplate\"></ng-container>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-add-bar/app-add-bar.component.html
// module id = ../../../../../src/app/components/app-add-bar/app-add-bar.component.html
// module chunks = main